/** @jsx jsx */
import { Flex, jsx } from 'theme-ui'
import { number } from 'prop-types'
import { Circle } from '../../icons'
import { generateArrayByLength } from './HelperFunctions'

const ProgressBar = ({ currentStep, totalStepNum }) => {
  let stepArray = generateArrayByLength(totalStepNum)
  return (
    <Flex
      sx={{
        flexDirection: 'row',
        mx: [3, 32],
        mb: 32,
        mt: 5,
      }}
    >
      {stepArray.map(num => {
        return currentStep === num ? (
          <Circle key={num} size={10} sx={{ backgroundColor: 'sky', mr: 5 }} />
        ) : (
          <Circle
            key={num}
            size={10}
            sx={{
              mr: 5,
              borderColor: 'sky',
              borderWidth: '1px',
              borderStyle: 'solid',
            }}
          />
        )
      })}
    </Flex>
  )
}
ProgressBar.propTypes = {
  currentStep: number,
  totalStepNum: number,
}

export default ProgressBar
